import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import useStoreDetails from 'hooks/useStoreDetails';
import JBLogo from '../../jb-logo';

const HeaderLogo = ({ className, linkTo = null }) => {
  const storeDetails = useStoreDetails();
  return (
    <span
      data-xc="header-logo"
      className={classNames(
        '[&_svg]:max-h-[28px] [&_div]:flex [&_div]:justify-center [&_div_p]:m-0 [&_a]:color-[unset] [&_a]:[text-decoration:unset]',
        className
      )}
    >
      <Link aria-label="Joybird" to={`${linkTo || '/'}`}>
        <JBLogo idSuffix="HeaderLogo" />
        <div>
          <p className="text-gray text-[13px] font-script non-italic font-normal mt-[5px] mr-0 mb-0 ml-2.5">
            {storeDetails && storeDetails.name}
          </p>
        </div>
      </Link>
    </span>
  );
};

HeaderLogo.propTypes = {
  className: PropTypes.string,
  linkTo: PropTypes.string,
};

export default HeaderLogo;
